import $ from 'jquery';

$(document).ready(function() {
    $(document).on('click', '.js-museums-group-item', function() {
    	$(this).toggleClass('active');
    	if ($('.js-museums-group-item.active').length > 0) {
    		$('.js-museums-group-reset').addClass('show');
    	} else {
    		$('.js-museums-group-reset').removeClass('show');
    	}
    });
    $(document).on('click', '.js-museums-group-reset', function() {
    	$('.js-museums-group-item').removeClass('active');
    	$(this).removeClass('show');
    });
    $(document).on('click', '.js-museums-sort-item', function() {
    	$('.js-museums-sort-item').removeClass('active');
    	$(this).addClass('active');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/museums/museums-sort.js